// extracted by mini-css-extract-plugin
export default {"drawerButton":"open-session-modal_drawerButton__PFKl0","drawerHint":"open-session-modal_drawerHint__dpVVo"};